import React, { useEffect, useState } from "react"
import styles from "./styles.css"
import iconFlag from "../../../../assets/svg/fixed_voice_dash_flag.svg"
import iconFlagWhite from "../../../../assets/svg/fixed_voice_dash_flag_white.svg"
import ButtonFixedVoice from "../../components/ButtonFixedVoice"
import { get, isNil } from "lodash"
import { connect } from "react-redux"
import ClientDetailsDash from "./ClientDetailsDash"
import Breadcrumb from "../../components/Breadcrumb"
import ClientNumbers from "./ClientNumbers"
import PropTypes from "prop-types"
import {
  getClientDetailsAssets,
  getClientDetailsOrders
} from "services/state/fixedVoice/action"

export const ClientDetails = ({
  history,
  customerDetails,
  occurrences,
  getClientDetailsAssets,
  getClientDetailsOrders
}) => {
  const hasRequests = get(occurrences, "totalRecords", 0) > 0
  const [type, setType] = useState("ASSET")
  const [status, setStatus] = useState("")

  const changeType = (type) => {
    setStatus("")
    setType(type)
  }

  const filterNumbers = (statusParam) => {
    setStatus(statusParam)
  }

  useEffect(() => {
    if (type === "ASSET") {
      getClientDetailsAssets(status)
    } else {
      getClientDetailsOrders(status)
    }
  }, [status])

  useEffect(() => {
    if (isNil(customerDetails)) {
      history.push({
        pathname: "/fixed-voice"
      })
    }
  }, [customerDetails])

  return (
    <div className={`fullHeight ${styles.container}`}>
      <Breadcrumb />
      <div className={styles.header}>
        <div>
          <h2>Detalhes do cliente</h2>
        </div>
        {hasRequests ? (
          <ButtonFixedVoice
            name={"Ver ou abrir solicitações ao especilista"}
            linkName={"specialist-requests"}
            icon={iconFlagWhite}
            hasBackgroundLink
          />
        ) : (
          <ButtonFixedVoice
            name={"Solicitar análise de especialista"}
            linkName={"specialist-analysis"}
            icon={iconFlag}
            isOutline={true}
          />
        )}
      </div>

      <div className={styles.tab}>
        <button
          id={"assets"}
          className={
            type === "ASSET"
              ? `${styles.tab_link_checked} ${styles.tab_link}`
              : styles.tab_link
          }
          onClick={() => changeType("ASSET")}
        >
          Números
        </button>
        <button
          id={"orders"}
          className={
            type === "ORDERS"
              ? `${styles.tab_link_checked} ${styles.tab_link}`
              : styles.tab_link
          }
          onClick={() => changeType("ORDERS")}
        >
          Protocolos
        </button>
      </div>

      <ClientDetailsDash
        customer={customerDetails}
        type={type}
        filter={filterNumbers}
      />

      <ClientNumbers
        customer={customerDetails}
        type={type}
        status={status}
        filter={filterNumbers}
      />
    </div>
  )
}

ClientDetails.propTypes = {
  history: PropTypes.object,
  occurrences: PropTypes.object,
  customerDetails: PropTypes.object,
  getClientDetailsAssets: PropTypes.func,
  getClientDetailsOrders: PropTypes.func
}

const mapStateToProps = ({ newOrder, customersFixedVoice }) => ({
  occurrences: newOrder.response,
  customerDetails: customersFixedVoice.customerDetails
})

const mapActionsToProps = {
  getClientDetailsAssets,
  getClientDetailsOrders
}

export default connect(mapStateToProps, mapActionsToProps)(ClientDetails)



// WEBPACK FOOTER //
// ./src/scenes/FixedVoice/Pages/ClientDetails/index.js